import { render, staticRenderFns } from "./ForumForm.vue?vue&type=template&id=de87dfce"
import script from "./ForumForm.vue?vue&type=script&lang=js"
export * from "./ForumForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports